var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 50.6C41.3771 50.6 50.6 41.3771 50.6 30C50.6 18.6229 41.3771 9.4 30 9.4C18.6229 9.4 9.4 18.6229 9.4 30C9.4 41.3771 18.6229 50.6 30 50.6ZM30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "#F7F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3227 30C57.9059 30 60.0372 27.8935 59.6361 25.3416C59.2689 23.0051 58.6257 20.7148 57.7164 18.5195C56.2087 14.8797 53.999 11.5726 51.2132 8.7868C48.4274 6.00104 45.1203 3.79125 41.4805 2.28361C39.2852 1.3743 36.9949 0.731147 34.6584 0.363878C32.1065 -0.0372358 30 2.09408 30 4.67725C30 7.26043 32.1202 9.30184 34.6374 9.88207C35.7496 10.1384 36.8412 10.4872 37.9007 10.9261C40.4055 11.9636 42.6815 13.4843 44.5986 15.4014C46.5157 17.3185 48.0364 19.5945 49.0739 22.0993C49.5128 23.1588 49.8616 24.2504 50.1179 25.3626C50.6982 27.8798 52.7396 30 55.3227 30Z",
    fill: "#BEC2CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.6e4525f72c432a401265b86e535873e9.svg";
export { ForwardRef as ReactComponent };